module.exports = __webpack_public_path__ + "static/media/BannerD5.859cb1f0.png";